<mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>


<div style="margin: 5px 10px;">
  <button mat-raised-button color="default" class="mr-1" (click)="goBack()">Back</button>
</div>


<ng-container *ngIf="invite">

  <mat-card class="content-card">
    <div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column">
      <div fxFlex="50">
        <h3>
          {{ invite.wallet.company.name }} - {{ invite.wallet.walletNumber }} ({{ invite.wallet.customName }})
        </h3>
      </div>
      <div fxFlex="50">
        <div style="text-align: right">

          <ng-container *ngIf="invite.identStatus === identStatus.pending">
            <span style="display: inline-block; background-color: orange; border-radius: 3px; padding: 2px 5px; margin: 0 5px;">Ident is pending</span>
          </ng-container>
          <ng-container *ngIf="invite.identStatus === identStatus.fail">
            <span style="display: inline-block; background-color: red; border-radius: 3px; padding: 2px 5px; margin: 0 5px;">Ident failed</span>
          </ng-container>

          <ng-container *ngIf="invite.isInviteApproved">
            <span style="display: inline-block; background-color: lightgreen; border-radius: 3px; padding: 2px 5px; margin: 0 5px;">Invite was approved</span>
          </ng-container>

          <ng-container *ngIf="invite.isInviteDeclined">
            <span style="display: inline-block; background-color: red; color: white; border-radius: 3px; padding: 2px 5px; margin: 0 5px;">Invite was declined</span>
          </ng-container>

          <ng-container *ngIf="invite.identStatus == identStatus.success">
          <button class="mr-2" mat-raised-button color="accent" [disabled]="invite.identStatus !== identStatus.success || invite.isInviteApproved || invite.isInviteDeclined" (click)="declineWithReason()">Decline</button>
          &nbsp;&nbsp;
          <button class="mr-2" mat-raised-button color="primary" [disabled]="invite.identStatus !== identStatus.success || invite.isInviteApproved || invite.isInviteDeclined" (click)="approve()">Approve</button>
          </ng-container>
        </div>
      </div>
    </div>

    <div>Application for wallet access: {{invite.inviteEmail}}</div>

  </mat-card>

  <div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column">
    <div fxFlex="50">

      <mat-card class="content-card">
        <mat-card-header>
          <mat-card-title>
            <h5>Application</h5>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>

          <h4>Company</h4>

          <div *ngIf="invite.thirdPartyCompany; else nocompany">
            <div class="list-item" fxLayout="row" *ngFor="let field of fieldsThirdPartyCompany">
              <app-content-row [field]="field" [entity]="invite.thirdPartyCompany"></app-content-row>
            </div>
          </div>
          <ng-template #nocompany>
            <div  style="border-radius: 5px; background-color: orange; padding: 5px;">
              No information about company present
            </div>
          </ng-template>

          <h4>Documents</h4>
          <table class="list-table" style="word-wrap:break-word; table-layout: fixed;">
            <tr>
              <th class="" style="text-align: left; width: 150px;"><label>Date</label></th>
              <th style="text-align: left;"><label>File</label></th>
              <th>Type</th>
              <th style="text-align: left; width: 50px;"></th>
              <th style="text-align: left; width: 50px;"></th>
            </tr>
            <tr *ngIf="invite.thirdPartyCompany?.registrationDocument != null; else noregistrationdocument">
              <td class=""><label>{{ invite.thirdPartyCompany?.registrationDocument.uploadDate | date: "dd.MM.yyyy HH:mm" }}</label></td>
              <td><label>{{invite.thirdPartyCompany?.registrationDocument.originalFileName}}</label></td>
              <td>Registration</td>
              <td>
                <button mat-mini-fab color="accent" (click)="downloadFile(invite.thirdPartyCompany?.registrationDocument.id)" aria-label="download">
                  <mat-icon matSuffix>cloud_download</mat-icon>
                </button>

              </td>
              <td>
                <button mat-mini-fab color="primary" (click)="openFile(invite.thirdPartyCompany?.registrationDocument.id)" aria-label="preview">
                  <mat-icon matSuffix>play_arrow</mat-icon>
                </button>
              </td>
            </tr>
            <ng-template #noregistrationdocument>
            <tr>
              <td colspan="5">

                <div style="border-radius: 5px; background-color: orange; padding: 5px;">
                  No registration document present
                </div>

              </td>
            </tr>
            </ng-template>
            <tr *ngIf="invite.thirdPartyCompany?.companyAgreementDocument != null; else nocompanyagreement">
              <td class=""><label>{{ invite.thirdPartyCompany.companyAgreementDocument.uploadDate | date: "dd.MM.yyyy HH:mm" }}</label></td>
              <td><label>{{invite.thirdPartyCompany.companyAgreementDocument.originalFileName}}</label></td>
              <td>Agreement</td>
              <td>
                <button mat-mini-fab color="accent" (click)="downloadFile(invite.thirdPartyCompany.companyAgreementDocument.id)" aria-label="download">
                  <mat-icon matSuffix>cloud_download</mat-icon>
                </button>

              </td>
              <td>
                <button mat-mini-fab color="primary" (click)="openFile(invite.thirdPartyCompany.companyAgreementDocument.id)" aria-label="preview">
                  <mat-icon matSuffix>play_arrow</mat-icon>
                </button>
              </td>
            </tr>
            <ng-template #nocompanyagreement>
              <tr>
                <td colspan="5">

                  <div style="border-radius: 5px; background-color: orange; padding: 5px;">
                    No company agreement document present
                  </div>

                </td>
              </tr>
            </ng-template>
          </table>

          <br/>
          <h4>Applicant</h4>
          <div *ngIf="invite.applicant; else noapplicant">
            <div class="list-item" fxLayout="row" >
              <b>{{invite.applicant.title}} {{invite.applicant.firstName}} {{invite.applicant.lastName|uppercase}}</b>
            </div>
            <div class="list-item" fxLayout="row" *ngFor="let field of fieldsApplicant">
              <app-content-row [field]="field" [entity]="invite.applicant"></app-content-row>
            </div>
            <div class="list-item" fxLayout="row">
              <b>Ident</b>
            </div>
            <div class="list-item" fxLayout="row" *ngFor="let field of fieldsIdent">
              <app-content-row [field]="field" [entity]="invite"></app-content-row>
            </div>
          </div>

          <ng-template #noapplicant>
            <div style="border-radius: 5px; background-color: orange; padding: 5px;">
              No information about applicant present
            </div>
          </ng-template>

          <br/>
          <h4>Other Shareholders</h4>
          <ng-container *ngIf="invite.thirdPartyCompany; else nothirdpartycompany">
            <div *ngFor="let person of invite.thirdPartyCompany.persons">
              <div *ngIf="person.id != invite.applicant.id">
                <div class="list-item" fxLayout="row">
                  <b>{{person.title}} {{person.firstName}} {{person.lastName|uppercase}}</b>
                </div>
                <div class="list-item" fxLayout="row" *ngFor="let field of fieldsPerson">
                  <app-content-row [field]="field" [entity]="person"></app-content-row>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-template #nothirdpartycompany>
            <div style="border-radius: 5px; background-color: orange; padding: 5px;">
              No information about other shareholders present
            </div>
          </ng-template>

        </mat-card-content>
      </mat-card>
    </div>

    <div fxFlex="50">

      <mat-card *ngIf="invite" class="content-card">
        <mat-card-header>
          <mat-card-title>
            <h5 *ngIf="filename == null">Preview</h5>
            <h5 *ngIf="filename != null">{{ filename }}</h5>
            <mat-error *ngIf="errorMsg != null">{{errorMsg}}</mat-error>

          </mat-card-title>
        </mat-card-header>
        <mat-card-content style="">

          <!--
          <div class="resp-container">
            <iframe class="resp-iframe" src="https://www.youtube.com/embed/dQw4w9WgXcQ" gesture="media"  allow="encrypted-media" allowfullscreen [hidden]="isFrameHidden" frameBorder="1" [src]="urlSafe"></iframe>
          </div>
          -->

          <iframe class="resp-iframe" height="1000" width="100%" [hidden]="isFrameHidden" frameBorder="1" [src]="urlSafe" ></iframe>
          <img [src]="urlSafe" style="width: 100%; height:auto;" [hidden]="isImgHidden"/>



        </mat-card-content>
      </mat-card>


    </div>
  </div>

</ng-container>
